import axios from "axios";
import { IRegistrationSheetData } from "../models/registrationModels";
import { PendingRequestResponse } from "../models/commonModels";

const _apiKey = process.env.REACT_APP_API_KEY;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export type ApiResponse = {
  success: boolean;
  errorCode?: string;
  errorMessage?: string;
};

const getRandomCode = (length: number): string => {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < length; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  };
  
  export const getPendingRequests = async (deviceName: string, tenantId: string) : Promise<PendingRequestResponse> => {
    const antiCacheToken = getRandomCode(5);
    const originalUrl = `VisitorRegistration/GetPendingRequests?deviceId=${deviceName}&rdm=${antiCacheToken}`;
    const requestUrl = `${API_BASE_URL}/${tenantId}/request/?remoteMethod=${encodeURIComponent(originalUrl)}`;
    const response = await axios.get(requestUrl, {
      headers: {
        "API-Key": _apiKey,
        "x-api-version": "1.0",
      },
    });
 
    return response.data;
  }
  
  export const getRegistrationSheet = async (database: string, registrationSheetId: number, tenantId: string): Promise<IRegistrationSheetData> => {
    const originalUrl = `VisitorRegistration/${database}/GetRegistrationSheet?id=${registrationSheetId}`;
    const requestUrl = `${API_BASE_URL}/${tenantId}/request/?remoteMethod=${encodeURIComponent(originalUrl)}`;
    const response = await axios.get(requestUrl, {
      headers: {
        "API-Key": _apiKey,
        "x-api-version": "1.0",
      },
    });
    if (response.status !== 200 || !response.data) {
      throw new Error('Failed to retrieve IRegistrationSheetData');
    }
    return response.data;
  }
  
  export const sendRegistrationSheetToAPI = async (signature: string, registrationSheetData: IRegistrationSheetData, database: string, tenantId: string) => {
    const data = { ...registrationSheetData, registrationSheet: { ...registrationSheetData.registrationSheet, signature } };
    const originalUrl = `VisitorRegistration/${database}/UpdateRegistrationSheet`;
    const requestUrl = `${API_BASE_URL}/${tenantId}/request/?remoteMethod=${encodeURIComponent(originalUrl)}`;
    return await axios.post(requestUrl, data, {
      headers: {
        "API-Key": _apiKey,
        "x-api-version": "1.0",
        "Content-Type": "application/json",
      },
    });
  }